var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPadlock = function SvgPadlock(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "16px",
    viewBox: "0 0 12 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Padlock") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Account-Security-Setup-1",
    transform: "translate(-625.000000, -269.000000)",
    fill: "#3C3C3C"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(464.000000, 136.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(127.000000, 133.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.000000, 0.000000)",
    id: "Icons/Padlock"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0 C10.1674571,0 11.9322714,1.72391888 11.9980966,3.87541033 L12,4 L12,6 L12.5,6 C13.2796961,6 13.9204487,6.59488808 13.9931334,7.35553999 L14,7.5 L14,14.5 C14,15.3284271 13.3284271,16 12.5,16 L12.5,16 L3.5,16 C2.67157288,16 2,15.3284271 2,14.5 L2,14.5 L2,7.5 C2,6.67157288 2.67157288,6 3.5,6 L3.5,6 L4,6 L4,4 L4.00190341,3.87541033 C4.06772857,1.72391888 5.83254287,0 8,0 Z M12.5,7 L3.5,7 C3.22385763,7 3,7.22385763 3,7.5 L3,7.5 L3,14.5 C3,14.7761424 3.22385763,15 3.5,15 L3.5,15 L12.5,15 C12.7761424,15 13,14.7761424 13,14.5 L13,14.5 L13,7.5 C13,7.22385763 12.7761424,7 12.5,7 L12.5,7 Z M8,9 L8.10896102,9.00586786 C8.60999027,9.06016012 9,9.48453423 9,10 C9,10.369681 8.79940038,10.6925095 8.5011143,10.8655723 L8.5,12.5 C8.5,12.7761424 8.27614237,13 8,13 C7.72385763,13 7.5,12.7761424 7.5,12.5 L7.4998705,10.8661429 C7.20104123,10.6932197 7,10.3700877 7,10 C7,9.48453423 7.39000973,9.06016012 7.89103898,9.00586786 L8,9 Z M8,1 C6.41577197,1 5.11278062,2.23020889 5.00727401,3.77949254 L5.00178673,3.890686 L5,4 L5,6 L11,6 L11.0001167,4.01527567 L10.9985643,3.90599115 C10.9491072,2.28948766 9.62194775,1 8,1 Z",
    id: "Icon"
  }))))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPadlock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/padlock.251bde6e3e20c5a0b8a834749d3e66ee.svg";